import React from "react";

type GalleryImage = {
    src: string;
    alt?: string;
    caption?: string;
};

type GalleryItemProps = {
    images: [GalleryImage] | [GalleryImage, GalleryImage]; // 1 or 2 images
    backgroundColor?: string;
    reversed?: boolean;
};

const GalleryItem: React.FC<GalleryItemProps> = ({
    images,
    backgroundColor = "#FFFFFF",
    reversed = false,
}) => {
    return (
        <section className="w-full py-16 md:py-24" style={{ backgroundColor }}>
            <div className={`container mx-auto flex flex-col ${reversed ? 'md:flex-row-reverse' : 'md:flex-row'} items-center px-6 md:px-12 lg:px-20`}>
                <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-8">
                    {/* First image (always present) */}
                    <figure className="flex flex-col items-center">
                        <img 
                            src={images[0].src}
                            alt={images[0].alt || "Gallery image 1"}
                            className="rounded-lg shadow-lg w-full object-cover"
                        />
                        {images[0].caption && (
                            <figcaption className="mt-2 text-sm text-gray-600 text-center">
                                {images[0].caption}
                            </figcaption>
                        )}
                    </figure>

                    {/* Second image or empty space */}
                    {images[1] ? (
                        <figure className="flex flex-col items-center">
                            <img 
                                src={images[1].src}
                                alt={images[1].alt || "Gallery image 2"}
                                className="rounded-lg shadow-lg w-full object-cover"
                            />
                            {images[1].caption && (
                                <figcaption className="mt-2 text-sm text-gray-600 text-center">
                                    {images[1].caption}
                                </figcaption>
                            )}
                        </figure>
                    ) : (
                        <div className="w-full h-full" aria-hidden="true" />
                    )}
                </div>
            </div>
        </section>
    );
};

export default GalleryItem;
